import type { UserInfoResponse } from '@routes/___shared___/user.api.ts';

export const getCrewUserRankName = (userInfo: UserInfoResponse | null) =>
    userInfo?.employmentDetails?.crewEmploymentDetails?.rankName || '';

export const getShoreUserTitleName = (userInfo: UserInfoResponse | null) =>
    userInfo?.employmentDetails?.shoreEmploymentDetails?.titleName || '';
